import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import { useFormik, FormikProvider, FieldArray } from "formik";
import { Apitoken, Authtoken } from "../Global";
import FindModuleById from '.././FindModuleById';

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const AddInvoice = () => {
  const [ordersLists, setOrdersLists] = useState([]);
  // const [invoiceTypesList, setInvoiceTypesList] = useState([]);
  const [countriesList, setCountriesList] = useState([]);
  const [productLists, setproductLists] = useState([]);
  const [menu, setMenu] = useState(false);
  const [showTableHeadings, setShowTableHeadings] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState('');
  const [showweight, setShowweight] = useState(true);
  const [permission, setPermission] = useState({});
  const [calibreLabel, setCalibreLabel] = useState('Calibre');

  const [invtype, setInvtype] = useState(false);


  const [customerNames, setcustomerNames] = useState([]);
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [defaultDate, setDefaultDate] = useState(formatDate(new Date()));
  let season_id = localStorage.getItem("season_id");
  let para = { season_id: season_id };


  const formik = useFormik({
    initialValues: {
      season_id: season_id,
      customer: "",
      order: "",
      date: defaultDate,
      invoicing_address: "",
      shipping_address: "",
      invoice_type: "",
      country: "149",
      tax: "",
      discount: "",

      // container: "",
      total_amount: "",
      total_gross_weight: "",
      total_number_of_boxes: "",
      remarks: "",

      contents: [],
    },
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/invoices/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          //  actions.setSubmitting(false);
          $("#form-submit").text("Add Invoice");
          setSubmitting(false);
          if (response.data.code === 200) {
            //setBackendSuccess(response.data.message);
            toast.success(response.data.message);
            // actions.resetForm();
            setTimeout(() => {
              window.location.href = "/invoices";
            }, 1000);
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const invoiceTypesList = [
    { value: '1', label: "Invoice" },
    { value: '4', label: "Produce Invoice" },
    { value: '2', label: "Credit Note" },
    { value: '3', label: "Proforma" },
  ];

  useEffect(() => {
    setPermission(FindModuleById(181));
    console.log(permission);

    axios
      .post(
        "/products/listing-category-type",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          let productslisting = products.map((customer, index) => ({
            label: customer.productname,
            value: customer.id,
            key: `address-${index}`,
          }));
          setproductLists(productslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });


    // axios
    //   .get("/helpers/invoice-types", {
    //     headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    //   })
    //   .then((response) => {
    //     if (response.data.code === 200) {
    //       let types = response.data.data.types;
    //       let typeslisting = types.map((customer, index) => ({
    //         label: customer.title,
    //         value: customer.id,
    //         key: `typee-${index}`,
    //       }));
    //       setInvoiceTypesList(typeslisting);
    //     } else {
    //       console.log("API response is not an array");
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });

    axios
      .get(`/helpers/countries`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let countries = response.data.data.countries;
          let countrieslisting = countries.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `country-${index}`,
          }));
          setCountriesList(countrieslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  const handleGetAddressByCustomerId = (event) => {
    setAddressList([]);
    //const customerid = event.value;
    const customerid = String(event.value);

    const parts = customerid.split("-");
    const customer_id = parts[0];              // always exists
    const customer_type = parts[1] ?? null;    // invoice or null
    if (customer_type === null) {


      axios.post(`/addresses/customer-address-by-customer/${customer_id}`, {}, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        if (response.data.code === 200) {

          let customers = response.data.data.addresses;
          console.log(customers);
          let addresses = customers.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `address-${index}`,
          }));

          setAddressList(addresses);
        }
      }).catch((error) => {
        console.log(error);
      });
      axios.get(`/helper/currency-by-customer/${customer_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        if (response.data.code === 200) {
          // console.log(response.data.data);
          setCurrencySymbol(response.data.data.customer_currency)

        }
      }).catch((error) => {
        console.log(error);
      });

    } else {
      if (customer_type == 'invoice') {


        axios.post(`/addresses/customer-address-by-customer/${customer_id}`, {}, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }).then((response) => {
          if (response.data.code === 200) {

            let customers = response.data.data.addresses;
            console.log(customers);
            let addresses = customers.map((customer, index) => ({
              label: customer.name,
              value: customer.id,
              key: `address-${index}`,
            }));

            setAddressList(addresses);
          }
        }).catch((error) => {
          console.log(error);
        });
        axios.get(`/helper/currency-by-customer/${customer_id}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }).then((response) => {
          if (response.data.code === 200) {
            // console.log(response.data.data);
            setCurrencySymbol(response.data.data.customer_currency)

          }
        }).catch((error) => {
          console.log(error);
        });
      } else {
        console.log(event);

           formik.setFieldValue('if', event.if);     formik.setFieldValue('ice', event.ice);

        axios.post(`/addresses/customer-address-by-supply-supplier/${customer_id}`, {}, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }).then((response) => {
          if (response.data.code === 200) {

            let customers = response.data.data.addresses;
            console.log(customers);
            let addresses = customers.map((customer, index) => ({
              label: customer.address,
              value: customer.address,
              key: `address-${index}`,
            }));

            setAddressList(addresses);
          }
        }).catch((error) => {
          console.log(error);
        });
      }

      // when "3-invoice"
      console.log("Type is:", customer_type);
    }
    console.log(event.value);

  }

  const handleGetAddressByCustomer = (event) => {
    const order_id = event.value;
    let customerid = 0;
    setAddressList([]);
    if (order_id != "") {
      axios
        .post(`/addresses/customer-address/${season_id + '-' + order_id}`, {}, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {

            let customers = response.data.data.addresses;
            customerid = response.data.data.customer_id;
            console.log(customers);
            let addresses = customers.map((customer, index) => ({
              label: customer.name,
              value: customer.id,
              key: `address-${index}`,
            }));
            setAddressList(addresses);
            axios.get(`/helper/currency-by-customer/${customerid}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            }).then((response) => {
              if (response.data.code === 200) {
                // console.log(response.data.data);
                setCurrencySymbol(response.data.data.customer_currency)

              }
            }).catch((error) => {
              console.log(error);
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });


    }
  };
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const changeInvoiceType = (event) => {
    const type = event.value;
    setAddressList([]);
    if (type == 1) {
      setOrdersLists([]);
      axios.post("/helpers/get-all-customers-supplychain-suppliers", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
        .then((response) => {
          // let customers = response.data.data.customers;
          if (response.data.code === 200) {
            let shipping_methods = response.data.data.customers;
            let customerOptions = shipping_methods.map((customer, index) => ({
              label: customer.company_name,
              value: customer.id,
              if: customer.if,
              ice: customer.ice,
              key: `customer-${index}`,
            }));
            setcustomerNames(customerOptions);
          } else {
            console.log("API response is not an array");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (type == 3 || type == 4) {
      setOrdersLists([]);
      axios.post("/helpers/get-all-customers", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
        .then((response) => {
          // let customers = response.data.data.customers;
          if (response.data.code === 200) {
            let shipping_methods = response.data.data.customers;
            let customerOptions = shipping_methods.map((customer, index) => ({
              label: customer.company_name,
              value: customer.id,
               if: customer.if,
              ice: customer.ice,
              key: `customer-${index}`,
            }));
            setcustomerNames(customerOptions);
          } else {
            console.log("API response is not an array");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setcustomerNames([]);
      axios
        .post("/orders/listing", para, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            let orders = response.data.data.orders;
            let orderslisting = orders.map((customer, index) => ({
              label: customer.po_number,
              value: customer.id,
              key: `address-${index}`,
            }));
            setOrdersLists(orderslisting);
          } else {
            console.log("API response is not an array");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    if (type == 1) {
      setInvtype(true);
    } else {
      setInvtype(false);
    }
    if (type == 1 || type == 2) {
      setShowweight(false);
      setCalibreLabel('Description'); // Change label to Description
    } else {
      setShowweight(true);
      setCalibreLabel('Calibre'); // Change label back to Calibre
    }


  }
  const getCurrncyByOrder = (event) => {
    const order_id = event.value;
    let season_id = localStorage.getItem("season_id");

    if (order_id != "") {

      axios
        .get(`/helper/currency-by-order/${season_id + '-' + order_id}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            // console.log(response.data.data);
            setCurrencySymbol(response.data.data.customer_currency)

          }
        })
        .catch((error) => {
          console.log(error);
        });

    }
  }
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };

  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Invoice</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/invoices">Invoice</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Invoice</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Invoice Header</h4>
                    {permission?.add == 1 && (
                      <FormikProvider value={formik}>
                        <form onSubmit={formik.handleSubmit}>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Invoice Type</label>
                                <Select
                                  className="w-100"
                                  value={invoiceTypesList.find(option => option.value == formik.values.invoice_type) || null} // Ensure correct format
                                  name="invoice_type"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("invoice_type", selectedOption);
                                    changeInvoiceType(selectedOption);


                                  }}
                                  onBlur={formik.handleBlur}
                                  options={invoiceTypesList}
                                  placeholder="Select"


                                />
                                <small>
                                  {backendErrors.invoice_type && (
                                    <span
                                      className="form-error mt-1"
                                      style={{ color: "red" }}
                                    >
                                      {backendErrors.invoice_type}
                                    </span>
                                  )}
                                </small>
                              </div>
                              {ordersLists.length > 0 && (
                                <div className="form-group order status">
                                  <label>Order PO Number</label>
                                  <Select

                                    className="w-100"
                                    value={ordersLists.find(option => option.value == formik.values.order) || null} // Ensure correct format
                                    name="order"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("order", selectedOption);
                                      handleGetAddressByCustomer(selectedOption);
                                      getCurrncyByOrder(selectedOption);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={ordersLists}
                                    placeholder="Select"


                                  />
                                  <small>
                                    {backendErrors.order && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.order}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              )}
                              {customerNames.length > 0 && (
                                <div className="form-group status">
                                  <label>Customer</label>
                                  <Select
                                    className="w-100"
                                    value={customerNames.find(option => option.value == formik.values.customer) || null} // Ensure correct format
                                    name="customer"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("customer", selectedOption);
                                      handleGetAddressByCustomerId(selectedOption);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={customerNames}
                                    placeholder="Select"


                                  />

                                  <small>
                                    {backendErrors.customer && (
                                      <span className="form-error mt-1">
                                        {backendErrors.customer}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              )}

                              <div className="form-group">
                                <label>Invoicing Address</label>

                                <Select
                                  className="w-100"
                                  value={addressList.find(option => option.value == formik.values.invoicing_address) || null} // Ensure correct format
                                  name="invoicing_address"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("invoicing_address", selectedOption);
                                    //handleGetAddressByCustomer(selectedOption);
                                    //getCurrncyByOrder(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={addressList}
                                  placeholder="Select"
                                />
                                <small>
                                  {backendErrors.invoicing_address && (
                                    <span
                                      className="form-error mt-1"
                                      style={{ color: "red" }}
                                    >
                                      {backendErrors.invoicing_address}
                                    </span>
                                  )}
                                </small>
                              </div>
                              {showweight && invtype === false && (
                                <div className="form-group">
                                  <label>Total Gross Weight</label>
                                  <input
                                    type="text"
                                    className="form-input form-control"
                                    name="total_gross_weight"
                                    value={formik.values.total_gross_weight}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.total_gross_weight && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.total_gross_weight}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              )}
                              {invtype && (
                                <div className="form-group">
                                  <label>IF</label>
                                  <input
                                    type="text"
                                    className="form-input form-control"
                                    name="if"
                                    value={formik.values.if}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.if && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.if}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              )}
                              {invtype && (
                                <div className="form-group">
                                  <label>Discount</label>
                                  <input
                                    type="text"
                                    className="form-input form-control"
                                    name="discount"
                                    value={formik.values.discount}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.discount && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.discount}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              )}

                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Date</label>
                                <input
                                  type="date"
                                  className="form-input form-control"
                                  name="date"
                                  value={formik.values.date}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    setDefaultDate(e.target.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.date && (
                                    <span
                                      className="form-error mt-1"
                                      style={{ color: "red" }}
                                    >
                                      {backendErrors.date}
                                    </span>
                                  )}
                                </small>
                              </div>
                              <div className="form-group">
                                <label>Shipping Address</label>

                                <Select
                                  className="w-100"
                                  value={addressList.find(option => option.value == formik.values.shipping_address) || null} // Ensure correct format
                                  name="shipping_address"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("shipping_address", selectedOption);
                                    //handleGetAddressByCustomer(selectedOption);
                                    //getCurrncyByOrder(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={addressList}
                                  placeholder="Select"


                                />
                                <small>
                                  {backendErrors.shipping_address && (
                                    <span
                                      className="form-error mt-1"
                                      style={{ color: "red" }}
                                    >
                                      {backendErrors.shipping_address}
                                    </span>
                                  )}
                                </small>
                              </div>

                              {invtype === false && (
                                <div className="form-group">
                                  <label>Country of Origin</label>
                                  <Select
                                    className="w-100"
                                    value={countriesList.find(option => option.value == formik.values.country) || null} // Ensure correct format
                                    name="country"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("country", selectedOption);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={countriesList}
                                    placeholder="Select"

                                  />
                                  <small>
                                    {backendErrors.country && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.country}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              )}


                              {showweight && invtype === false && (
                                <div className="form-group">
                                  <label>Total Number Of Boxes</label>
                                  <input
                                    type="text"
                                    className="form-input form-control"
                                    name="total_number_of_boxes"
                                    value={formik.values.total_number_of_boxes}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.total_number_of_boxes && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.total_number_of_boxes}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              )}

                              {invtype && (
                                <div className="form-group">
                                  <label>ICE</label>
                                  <input
                                    type="text"
                                    className="form-input form-control"
                                    name="ice"
                                    value={formik.values.ice}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.ice && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.ice}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              )}
                              {invtype && (
                                <div className="form-group">
                                  <label>TAX</label>
                                  <input
                                    type="text"
                                    className="form-input form-control"
                                    name="tax"
                                    value={formik.values.tax}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.tax && (
                                      <span
                                        className="form-error mt-1"
                                        style={{ color: "red" }}
                                      >
                                        {backendErrors.tax}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              )}



                            </div>

                            <div className="col-md-12">
                              <div className="form-group">
                                <label>Remarks</label>
                                <input
                                  type="text"
                                  className="form-input form-control"
                                  name="remarks"
                                  value={formik.values.remarks}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                            </div>



                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Invoice Items
                              </h4>
                            </div>
                          </div>
                          <FieldArray
                            name="contents"
                            render={(arrayHelpers) => (
                              <div>
                                <button
                                  className="btn btn-primary mb-3"
                                  type="button"
                                  onClick={() => {
                                    let appendArr = arrayHelpers.form.values.contents[0];
                                    let initialArr = {
                                      product: "",
                                      calibre: "",
                                      quantity: "",
                                      price: "",
                                      // number_of_boxes: "",
                                    }
                                    appendArr = (appendArr) ? appendArr : initialArr;
                                    arrayHelpers.push(appendArr);
                                    setShowTableHeadings(true);

                                    // arrayHelpers.push({
                                    //   product: "",
                                    //   calibre: "",
                                    //   quantity: "",
                                    //   price: "",
                                    //   // amount: "",
                                    // });
                                    // setShowTableHeadings(true);
                                  }}
                                >
                                  +
                                </button>
                                <table className="table">
                                  {showTableHeadings && (
                                    <thead>
                                      <tr>
                                        {invtype === false && (<th>Product</th>)}

                                        <th>{calibreLabel}</th>
                                        <th>Quantity</th>
                                        <th>Price</th>
                                        {/* <th>Amount</th> */}
                                        {/* <th>Action</th> */}
                                      </tr>
                                    </thead>
                                  )}
                                  <tbody>
                                    {formik.values.contents.map(
                                      (friend, index) => (
                                        <tr key={index}>
                                          {invtype === false && (
                                            <td>
                                              <div className="form-group status">
                                                <Select
                                                  name={`contents[${index}].product`}
                                                  options={productLists}
                                                  value={productLists.find(option => option.value == formik.values.contents[index].product) || null} // Ensure correct format
                                                  onChange={(selectedOption) => {
                                                    formik.setFieldValue(`contents[${index}].product`, selectedOption.value); // ✅ Store only value in Formik
                                                    customHandleInput({
                                                      target: {
                                                        name: `contents[${index}].product`,
                                                        value: selectedOption.value, // ✅ Ensure only value is passed
                                                      },
                                                    });
                                                  }}
                                                  onBlur={formik.handleBlur}
                                                  placeholder="Select"
                                                  className="w-100"


                                                />
                                              </div>
                                            </td>

                                          )}


                                          <td>
                                            <div className="form-group status">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`contents[${index}].calibre`}
                                                value={
                                                  formik.values.contents[index]
                                                    .calibre
                                                }
                                                onChange={formik.handleChange}
                                                placeholder={`Enter ${calibreLabel}`}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="form-group status">
                                              <input
                                                type="text"
                                                onKeyPress={(event) => {
                                                  // Allow only numbers (0-9)
                                                  if (!/^[0-9]$/.test(event.key)) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                placeholder="Enter Quantity"
                                                className="form-input form-control"
                                                name={`contents[${index}].quantity`}
                                                value={
                                                  formik.values.contents[index]
                                                    .quantity
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="form-group status">

                                              <div className="input-group">
                                                <input
                                                  type="text"
                                                  onKeyPress={(event) => {
                                                    // Allow only numbers (0-9)
                                                    if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                  placeholder="Enter Price"
                                                  className="form-input form-control"
                                                  name={`contents[${index}].price`}
                                                  value={
                                                    formik.values.contents[index]
                                                      .price
                                                  }
                                                  onChange={formik.handleChange}

                                                  aria-label="priceCost" aria-describedby="basic-addon2" />
                                                <div className="input-group-append">
                                                  <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                                </div>
                                              </div>


                                            </div>
                                          </td>

                                          <td>
                                            <div className="form-group">
                                              <button
                                                className="btn btn-danger"
                                                // style={{ marginTop: 30 }}
                                                type="button"
                                                onClick={() =>
                                                  arrayHelpers.remove(index)
                                                }
                                              >
                                                -
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          />

                          <div className="text-end mt-4">
                            <button className="btn btn-primary" type="submit" id="form-submit" disabled={formik.isSubmitting}>
                              Add Invoice
                            </button>
                          </div>
                        </form>
                      </FormikProvider>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddInvoice;
